/**
 * Strumenti dell'ambiente nella pagina Admin (product-service, solo SYSTEM_CONFIGURATION).
 *
 * Endpoint:
 *   GET /api/products/admin/tools                     → link Mailpit / UI DT + disponibilità password
 *   GET /api/products/admin/tools/dt-admin-password   → { password } (letta solo al click "copia")
 *   GET /api/products/admin/tools/env-file            → { path, content } — SOLO DEV, da rimuovere
 *                                                       prima della produzione (ADMIN_ENV_VIEWER=1)
 */

import { createServiceClient } from '../../api/client.js';

export interface AdminTools {
  /** URL assoluto o forma `:porta[/path]` (stesso hostname del portale, http). */
  mailpitUrl: string | null;
  dtUiUrl: string | null;
  dtAdminPasswordAvailable: boolean;
  /** SOLO DEV: il visualizzatore del file `.env` del server è abilitato (ADMIN_ENV_VIEWER=1). */
  envViewerEnabled?: boolean;
}

/** Contenuto integrale del file `.env` del server (SOLO DEV, segreti inclusi). */
export interface AdminEnvFile {
  path: string;
  content: string;
}

const productApi = createServiceClient('product');

export function fetchAdminTools(): Promise<AdminTools> {
  return productApi<AdminTools>('/admin/tools');
}

/** Password admin di Dependency-Track: mai messa in cache, letta solo per copiarla. */
export async function fetchDtAdminPassword(): Promise<string> {
  const res = await productApi<{ password: string }>('/admin/tools/dt-admin-password');
  return res.password;
}

/** SOLO DEV: legge il `.env` del server (ogni lettura è registrata nel log audit). */
export function fetchAdminEnvFile(): Promise<AdminEnvFile> {
  return productApi<AdminEnvFile>('/admin/tools/env-file');
}

/**
 * Risolve l'URL di uno strumento: la forma `:porta[/path]` diventa `http://<hostname del
 * portale>:porta/...` (Mailpit e UI DT sono servizi http pubblicati sullo stesso host).
 */
export function resolveToolUrl(value: string, hostname: string): string {
  if (!value.startsWith(':')) return value;
  const [porta, ...path] = value.slice(1).split('/');
  return `http://${hostname}:${porta}/${path.join('/')}`;
}
